module.exports = __webpack_public_path__ + "static/media/1001481DO.913f46bc.jpg";